import { cn } from "../lib/cn";

export interface StatCardProps {
  value: string;
  label: string;
  variant?: "ghost" | "solid";
  className?: string;
}

export function StatCard({
  value,
  label,
  variant = "solid",
  className,
}: StatCardProps) {
  return (
    <div className={cn("flex flex-col", className)}>
      <span
        className={cn(
          "font-serif text-5xl leading-[1.08]",
          variant === "ghost" &&
            "text-transparent [-webkit-text-stroke:1.5px_rgba(201,168,76,0.60)]",
          variant === "solid" && "text-gold/75",
        )}
      >
        {value}
      </span>
      <span className="text-text-muted mt-2 font-mono text-[10px] uppercase tracking-[0.15em]">
        {label}
      </span>
    </div>
  );
}
